<template>
  <div class="import-transferencias">
    <b-row>
      <b-col cols="12" xl="12">
        <b-card header="Importar Transferencias">
          <b-form>
            <b-form-group
                description="Listado de transferencias en formato csv (separados por coma)">
              <b-form-file 
                v-model="file" 
                class="mt-3" 
                accept=".csv" 
                placeholder="Seleccione un archivo o arrastrelo hasta aquí">
              </b-form-file>
            </b-form-group>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="importarTransferencias">Importar</b-button>
            <b-button size="sm" variant="primary" class="footer-button"
              :disabled="!file" 
              @click.prevent="cancelar">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>      
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'importTransferencias/getField',
  mutationType: 'importTransferencias/updateField',
});

export default {
  name: 'ImportTransferenciasFile',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal 
  ],
  data: () => {
    return {
      file: null,
    }
  },
  computed: {
    ...mapFields([
      'transferencias',
    ]),
  },
  created() {
    this.$store.dispatch('importTransferencias/inicializar');
  },  
  methods: {
    importarTransferencias() {
      if (this.file) {
        this.showSpinner();
        this.$store.dispatch('importTransferencias/importarReporte', this.file)
          .then(() => this.$router.push({ name: 'ImportTransferenciasParticipantes' }))
          .catch(error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner());
      } else {
        this.showErrorMsj ('Seleccione un archivo para importar');
      }
    },
    cancelar() {
      this.file = null;
    },
  },
  watch: {
    'file' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.importarTransferencias();
      }
    },      
  }
}
</script>

<style>
</style>
